import React, {useContext} from 'react';
import {TextField} from "@mui/material";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import {languages} from "../../../strings/LanguageDictionary";
import {AppContext} from "../../../App";


const CustomMultiText = ({
	                         inputRef,
	                         name,
	                         label,
	                         autoFocus,
	                         autoComplete,
	                         type,
	                         inputProps,
	                         error,
	                         disabled,
	                         rows = 5,
	                         placeholder,
	                         classes = "",
	                         handleKeyDown,
	                         variant = "outlined"
                         }) => {
	const appContext = useContext(AppContext);
	
	return (
		<React.Fragment>
			<TextField
				onKeyDown={(event) => handleKeyDown ? handleKeyDown(event) : {}}
				placeholder={placeholder}
				inputRef={inputRef}
				name={name}
				label={label}
				autoFocus={autoFocus}
				autoComplete={autoComplete}
				type={type}
				fullWidth={true}
				variant={variant}
				multiline={true}
				rows={rows}
				disabled={disabled}
				error={error !== undefined}
				className={classes}
				helperText={error?.type === "validate" ? languages[appContext.state.lang].OCEAN__GLOBAL_NOT_VALID_FILES : error?.message ? languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_ : ""}
				slotProps={{
					htmlInput: inputProps,
					formHelperText: {
						style: getHelperStyle().helper
					}
				}}
			/>
		</React.Fragment>
	);
}

export default React.memo(CustomMultiText)
